import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './featured-article.scss.js';
import '../nav-link/index.js';

class FeaturedArticle extends s {
    constructor() {
        super(...arguments);
        this.text = '';
        this.linkText = '';
        this.linkHref = '';
        this.ariaLabel = '';
        this.regionLabel = 'Featured article';
        this.isNoFollow = false;
        this.target = '';
    }
    render() {
        return $ `<div class="featured-article" role="region" aria-labelledby="featured-article-heading"><h3 id="featured-article-heading" class="featured-article__text">${this.text}</h3><nav-link .text="${this.linkText}" .href="${this.linkHref}" .ariaLabel="${this.ariaLabel}" .icon="${this.navIcon}" .isNoFollow="${this.isNoFollow}" .target="${this.target}"></nav-link></div>`;
    }
}
FeaturedArticle.styles = css_248z;
__decorate([
    e()
], FeaturedArticle.prototype, "text", void 0);
__decorate([
    e()
], FeaturedArticle.prototype, "linkText", void 0);
__decorate([
    e()
], FeaturedArticle.prototype, "linkHref", void 0);
__decorate([
    e()
], FeaturedArticle.prototype, "ariaLabel", void 0);
__decorate([
    e()
], FeaturedArticle.prototype, "regionLabel", void 0);
__decorate([
    e()
], FeaturedArticle.prototype, "navIcon", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], FeaturedArticle.prototype, "isNoFollow", void 0);
__decorate([
    e({ type: String, reflect: true })
], FeaturedArticle.prototype, "target", void 0);
customElements.define('featured-article', FeaturedArticle);

export { FeaturedArticle };
